import { create } from "zustand";
import { devtools } from "zustand/middleware";

import type { QuickFilterId } from "./KeywordsBreakdownQuickFilters";

interface IQuickFilterIntentState {
    /** A quick filter requested from outside the table (e.g. a metric card "See full list" link). */
    requestedQuickFilter: QuickFilterId | undefined;
}

interface IQuickFilterIntentStore extends IQuickFilterIntentState {
    requestQuickFilter: (quickFilter: QuickFilterId) => void;
    consumeRequestedQuickFilter: () => void;
}

export const useKeywordsBreakdownQuickFilterIntent = create<IQuickFilterIntentStore>()(
    devtools(
        (set) => ({
            requestedQuickFilter: undefined,
            requestQuickFilter: (quickFilter) => set({ requestedQuickFilter: quickFilter }),
            consumeRequestedQuickFilter: () => set({ requestedQuickFilter: undefined }),
        }),
        { name: "KeywordsBreakdownQuickFilterIntent" },
    ),
);
